<template>
  <div class="page-content">
    <div class="row chat-wrapper" style="height: auto !important">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="card">
          <div class="card-body">
            <div class="row position-relative">
              <div class="col-lg-4 chat-aside border-lg-right">
                <div class="aside-content">
                  <div class="aside-header">
                    <el-input placeholder="Search emails" prefix-icon="el-icon-search" class="search-bar"/>
                  </div>
                  <div class="aside-body">
                    <div class="tab-content" style="min-height: calc(100vh - 275px); height: auto;">
                      <div class="tab-pane fade show active chat-list">
                        <ul class="list-unstyled chat-list px-1">
                          <li class="chat-item pr-1" v-for="email in emails" :key="email.id" @click="selectEmail(email)">
                            <a href="javascript:;" class="d-flex align-items-center">
                              <div class="flex-grow border-bottom">
                                <div class="d-flex justify-content-between align-items-center truncate">
                                  <div class="d-flex flex-column mb-2">
                                    <p style="max-width: 50%;" class="tx-14 font-weight-bold text-body">
                                      {{ truncate(email.sender + '&lt;' + email.email + '&gt;', 30) }}
                                    </p>
                                  </div>
                                  <p class="text-muted tx-12 mb-1 text-right">
                                    <span>Yesterday</span>
                                    <!-- 9 seconds ago -->
                                  </p>
                                </div>
                                <p class="tx-12 preview-chat" :class="{ 'text-muted': email.last_msg.type == 'out', 'inbound-text': email.last_msg.type == 'in', 'font-weight-bold': email.last_msg.type == 'in' }">
                                  {{ email.subject }}
                                </p>
                                <p class="text-muted tx-12">
                                  {{ email.snippet }}
                                </p>
                              </div>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="chat-content col-lg-8">
                <div class="chat-header border-bottom pb-2">
                  <span class="font-weight-bold">{{ selectedEmail.subject }}</span>
                </div>
                <div class="chat-body pr-3">
                  <div class="card mb-2">
                    <div class="card-header">
                      <div class="d-flex align-items-center">
                        <el-avatar size="small" :src="'https://api.dicebear.com/9.x/initials/svg?seed=' + selectedEmail.sender"></el-avatar>
                        <div class="ml-2">
                          <p>
                            <span class="font-weight-bold">{{ selectedEmail.sender }}</span>&nbsp;
                            <span class="text-muted tx-13">&lt;{{ selectedEmail.email }}&gt;</span>
                          </p>
                          <p class="text-muted tx-13">
                            <span>To: <a class="text-body" :key="e" :href="'mailto:' + e" v-for="e in selectedEmail.to.split(',')">{{ e }}</a></span>
                            &nbsp;
                            <span>Cc: <a class="text-body" :key="e" :href="'mailto:' + e" v-for="e in selectedEmail.cc.split(',')">{{ e }};</a></span>
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="card-body">
                      <div ref="emailContainer" v-html="processedEmail(selectedEmail.body)"></div>
                      <el-divider/>
                      <div class="email-actions">
                        <el-button size="mini"><font-awesome icon="reply"/> Reply</el-button>
                        <el-button size="mini"><font-awesome icon="reply-all"/> Reply all</el-button>
                        <el-button size="mini"><font-awesome icon="share"/> Forward</el-button>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="card">
                    <div class="card-body">
                      <div v-html="selectedEmail.body"></div>
                      <el-divider/>
                      <div class="email-actions">
                        <el-button size="mini"><font-awesome icon="reply"/> Reply</el-button>
                        <el-button size="mini"><font-awesome icon="reply-all"/> Reply all</el-button>
                        <el-button size="mini"><font-awesome icon="share"/> Forward</el-button>
                      </div>
                    </div>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { toSvg } from 'jdenticon';
import { truncate } from 'lodash';
import PerfectScrollbar from 'perfect-scrollbar';

export default {
  metaInfo: {
    title: 'Email Inbox',
  },
  data() {
    return {
      emails: [],
      selectedEmail: null,
      perfectScroll: [],
    };
  },
  mounted() {
    let body = '<div dir="ltr"><div>testing</div><div><br></div><span class="gmail_signature_prefix">-- </span><br><div dir="ltr" class="gmail_signature" data-smartmail="gmail_signature"><div dir="ltr"><div><i>Best Regards,</i></div><i><b>Yanuar Anggianto</b></i><div><i>---------------------------<br></i><div><i><img width="96" height="96" src="https://ci3.googleusercontent.com/mail-sig/AIorK4yve6LE6hFikz_x-sTT2JSW5o6uSghOaW313E8ajYprEhnmFRoNeUSBoqNm6c4VSy3KRvj5oyMfWy9D"></i></div></div></div></div></div>\r\n\r\n<br>\r\n<div style="direction:ltr;margin:8px 0px 0px;padding:0px;font-size:0.875rem;overflow-x:hidden;color:rgb(34,34,34);font-family:&quot;Google Sans&quot;,Roboto,RobotoDraft,Helvetica,Arial,sans-serif"><div style="font-stretch:normal;font-size:small;line-height:1.5;font-family:Arial,Helvetica,sans-serif;overflow:auto hidden;direction:initial"><div dir="ltr"><div>“<i>This electronic mail and its attachment(s) is intended only for the recipient(s) to whom it is addressed. It may contain information which may be confidential and/or protected by legal privilege. If you are not the intended recipient(s), reading, disclosing, printing, copying, forwarding this electronic mail and its attachment(s) and/or taking any action in reliance on the information in this electronic mail and its attachment(s) are prohibited. PT Mari Works Solution shall not be liable in respect of communication made by its employee which is contrary to the company policy and/or outside the scope of the employment of the individual concerned. The employee will be personally liable for any damages or other liability arising.</i>”<br><br>“Surat elektronik ini beserta lampirannya ditujukan hanya untuk penerima surat yang dituju. Surat elektronik ini mungkin mengandung informasi yang bersifat rahasia dan/atau dilindungi oleh hukum. Jika Anda bukan penerima yang dituju, Anda tidak diperkenankan untuk membaca, menyebarkan, mencetak, menyalin, meneruskan surat elektronik ini beserta lampirannya dan/atau mengambil tindakan apapun berdasarkan informasi yang terdapat dalam surat elektronik ini beserta lampirannya. PT Mari Works Solution tidak bertanggung jawab atas setiap komunikasi karyawan yang bertentangan dengan kebijakan perusahaan dan/atau berada di luar lingkup pekerjaannya. Segala resiko dan dampak yang ditimbulkan merupakan tanggung jawab karyawan terkait.“<br></div></div></div></div>';
    for (let i = 1; i < 10; i += 1) {
      if (i === 2) {
        /* eslint-disable max-len */
        body = '<div dir="ltr">Yes, received. <br></div><br><div class="gmail_quote gmail_quote_container"><div dir="ltr" class="gmail_attr">On Fri, 14 Feb 2025 at 14:05, Yanuar Anggianto &lt;<a href="mailto:yanuar@wappin.app">yanuar@wappin.app</a>&gt; wrote:<br></div><blockquote class="gmail_quote" style="margin:0px 0px 0px 0.8ex;border-left:1px solid rgb(204,204,204);padding-left:1ex"><div><div id="m_7374812556514915345editor_version_1.26.4_33c8MLe5" style="word-break:break-word"><div style="margin-top:4px;margin-bottom:4px;line-height:1.6"><div style="font-size:14px">Test reply all\r\n</div></div></div><div id="m_7374812556514915345lark-mail-quote-173951672"><div style="list-style-position:inside"><div style="border-left:none;padding-left:0px"><div><div id="m_7374812556514915345lark-mail-quote-b001935504c3fa3f174c33e813cdc5ee"><div id="m_7374812556514915345lark-mail-quote-meta-8oaBUhHE2" style="padding:12px;background:rgb(245,246,247);color:rgb(31,35,41);border-radius:4px;margin-top:24px;margin-bottom:12px">OnFri, Feb 14, 2025, 13:37 &lt;<a style="white-space:pre-wrap;word-break:break-word;text-decoration:none;color:inherit" href="mailto:yanuar@mariworks.id" target="_blank">yanuar@mariworks.id</a>&gt; wrote:</div><div><div dir="ltr"><div>dan bcc</div><div><br></div><span class="gmail_signature_prefix">-- </span><br><div class="gmail_signature" dir="ltr"><div dir="ltr"><div><i>Best Regards,</i></div><i><b>Yanuar Anggianto</b></i><div><i>---------------------------<br></i><div><i><img src="https://ci3.googleusercontent.com/mail-sig/AIorK4yve6LE6hFikz_x-sTT2JSW5o6uSghOaW313E8ajYprEhnmFRoNeUSBoqNm6c4VSy3KRvj5oyMfWy9D" height="96" width="96"></i></div></div></div></div></div><br><div style="direction:ltr;margin:8px 0px 0px;padding:0px;font-size:0.875rem;overflow-x:hidden;color:rgb(34,34,34);font-family:&quot;Google Sans&quot;,Roboto,RobotoDraft,Helvetica,Arial,sans-serif"><div style="font-stretch:normal;font-size:small;line-height:1.5;font-family:Arial,Helvetica,sans-serif;overflow:auto hidden;direction:initial"><div dir="ltr"><div>“<i>This electronic mail and its attachment(s) is intended only for the recipient(s) to whom it is addressed. It may contain information which may be confidential and/or protected by legal privilege. If you are not the intended recipient(s), reading, disclosing, printing, copying, forwarding this electronic mail and its attachment(s) and/or taking any action in reliance on the information in this electronic mail and its attachment(s) are prohibited. PT Mari Works Solution shall not be liable in respect of communication made by its employee which is contrary to the company policy and/or outside the scope of the employment of the individual concerned. The employee will be personally liable for any damages or other liability arising.</i>”<br><br>“Surat elektronik ini beserta lampirannya ditujukan hanya untuk penerima surat yang dituju. Surat elektronik ini mungkin mengandung informasi yang bersifat rahasia dan/atau dilindungi oleh hukum. Jika Anda bukan penerima yang dituju, Anda tidak diperkenankan untuk membaca, menyebarkan, mencetak, menyalin, meneruskan surat elektronik ini beserta lampirannya dan/atau mengambil tindakan apapun berdasarkan informasi yang terdapat dalam surat elektronik ini beserta lampirannya. PT Mari Works Solution tidak bertanggung jawab atas setiap komunikasi karyawan yang bertentangan dengan kebijakan perusahaan dan/atau berada di luar lingkup pekerjaannya. Segala resiko dan dampak yang ditimbulkan merupakan tanggung jawab karyawan terkait.“<br></div></div></div></div></div></div></div></div></div></div></div></blockquote></div><div><br clear="all"></div><div><br></div><span class="gmail_signature_prefix">-- </span><br><div dir="ltr" class="gmail_signature"><div dir="ltr"><div><i>Best Regards,</i></div><i><b>Yanuar Anggianto</b></i><div><i>---------------------------<br></i><div><i><img width="96" height="96" src="https://ci3.googleusercontent.com/mail-sig/AIorK4yve6LE6hFikz_x-sTT2JSW5o6uSghOaW313E8ajYprEhnmFRoNeUSBoqNm6c4VSy3KRvj5oyMfWy9D"></i></div></div></div></div>\r\n\r\n<br>\r\n<div style="direction:ltr;margin:8px 0px 0px;padding:0px;font-size:0.875rem;overflow-x:hidden;color:rgb(34,34,34);font-family:&quot;Google Sans&quot;,Roboto,RobotoDraft,Helvetica,Arial,sans-serif"><div style="font-stretch:normal;font-size:small;line-height:1.5;font-family:Arial,Helvetica,sans-serif;overflow:auto hidden;direction:initial"><div dir="ltr"><div>“<i>This electronic mail and its attachment(s) is intended only for the recipient(s) to whom it is addressed. It may contain information which may be confidential and/or protected by legal privilege. If you are not the intended recipient(s), reading, disclosing, printing, copying, forwarding this electronic mail and its attachment(s) and/or taking any action in reliance on the information in this electronic mail and its attachment(s) are prohibited. PT Mari Works Solution shall not be liable in respect of communication made by its employee which is contrary to the company policy and/or outside the scope of the employment of the individual concerned. The employee will be personally liable for any damages or other liability arising.</i>”<br><br>“Surat elektronik ini beserta lampirannya ditujukan hanya untuk penerima surat yang dituju. Surat elektronik ini mungkin mengandung informasi yang bersifat rahasia dan/atau dilindungi oleh hukum. Jika Anda bukan penerima yang dituju, Anda tidak diperkenankan untuk membaca, menyebarkan, mencetak, menyalin, meneruskan surat elektronik ini beserta lampirannya dan/atau mengambil tindakan apapun berdasarkan informasi yang terdapat dalam surat elektronik ini beserta lampirannya. PT Mari Works Solution tidak bertanggung jawab atas setiap komunikasi karyawan yang bertentangan dengan kebijakan perusahaan dan/atau berada di luar lingkup pekerjaannya. Segala resiko dan dampak yang ditimbulkan merupakan tanggung jawab karyawan terkait.“<br></div></div></div></div>';
      }
      this.emails.push({
        id: i,
        sender: 'Sofyan Dharma Adjie',
        email: 'sofyan@mariworks.id',
        time: 'Yesterday',
        subject: `New API - ${i}`,
        snippet: 'Dear Team, Kindly check...',
        body,
        last_msg: {
          status: 'read',
          type: 'in',
        },
        cc: 'yanuar@wappin.app, yanuar.yanuar1@gmail.com',
        to: 'support@mail.tixfly.id',
      });
    }
    this.selectEmail(this.emails[0]);

    this.$nextTick(() => {
      if (document.querySelectorAll('.chat-aside .tab-content').length) {
        this.perfectScroll.push(new PerfectScrollbar('.chat-aside .tab-content'));
      }
      if (document.querySelectorAll('.chat-content .chat-body').length) {
        this.perfectScroll.push(new PerfectScrollbar('.chat-content .chat-body'));
      }
      if (document.querySelectorAll('.chat-history').length) {
        this.perfectScroll.push(new PerfectScrollbar('.chat-history'));
      }
      this.$refs.emailContainer.addEventListener('click', this.handleThreadToggle);
    });
  },
  methods: {
    processedEmail(content) {
      return this.truncateEmailThread(content);
    },
    truncateEmailThread(html) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // Select common quoted email elements
      const quoteSelectors = [
        '.history-quote-wrapper', // Lark Mail
        '.gmail_quote', // Gmail
        'blockquote', // Outlook/Gmail
        'div[style*="border-left"]', // Generic quoted text
      ];

      quoteSelectors.forEach((selector, idx) => {
        doc.querySelectorAll(selector).forEach((elem) => {
          // Wrap quoted content in a div and hide it
          const hiddenDiv = document.createElement('div');
          hiddenDiv.className = 'hidden-thread';
          hiddenDiv.id = `hidden-thread-${idx}`;
          hiddenDiv.style.display = 'none';
          hiddenDiv.innerHTML = elem.innerHTML;

          // Create the ellipsis button
          const button = document.createElement('button');
          button.className = 'el-button el-button--text toggle-thread';
          button.innerText = '...';
          button.id = `toggle-thread-${idx}`;
          button.dataset.target = `toggle-thread-${idx}`;

          // Replace quoted content with button + hidden div
          elem.innerHTML = '';
          elem.appendChild(button);
          elem.appendChild(hiddenDiv);
        });
      });

      return doc.body.innerHTML;
    },
    truncate(string, length) {
      return truncate(string, { length });
    },
    selectEmail(email) {
      this.selectedEmail = email;
    },
    identicons(value) {
      return toSvg(value, '40');
    },
    handleThreadToggle(event) {
      if (event.target.classList.contains('toggle-thread')) {
        const threadId = event.target.dataset.target;
        const thread = document.getElementById(threadId.replace('toggle', 'hidden'));
        console.log('thread', threadId, thread);
        if (thread) {
          if (thread.style.display === 'none') {
            thread.style.display = 'block';
            event.target.innerText = 'Hide';
          } else {
            thread.style.display = 'none';
            event.target.innerText = '...';
          }
        }
      }
    },
  },
};
</script>

<style scoped>
.sidebar {
  width: 250px; border-right: 1px solid #ddd;
}
.full-width {
  width: 100%;
}
.badge {
  margin-left: auto;
}
.main-content {
  display: flex; flex: 1;
}
.email-list {
  width: 30%; padding: 16px; border-right: 1px solid #ddd;
}
.search-bar {
  margin-bottom: 16px;
}
.email-item {
  cursor: pointer; padding: 8px; border-bottom: 1px solid #eee;
}
.highlight {
  color: #f0a500;
}
.timestamp {
  font-size: 12px; color: gray; margin-left: 8px;
}
.subject {
  font-weight: bold;
}
.snippet {
  font-size: 12px; color: gray;
}
.email-detail {
  flex: 1; padding: 24px;
}
.email-title {
  font-size: 18px; font-weight: bold;
}
.email-meta {
  font-size: 14px; color: gray; margin-bottom: 16px;
}
.email-body {
  border-top: 1px solid #ddd; padding-top: 16px; margin-bottom: 16px;
}
.email-actions {
  display: flex; gap: 8px;
}
[data-initials]:before {
  background: #8CC8ED;
  color: white;
  opacity: 1;
  content: attr(data-initials);
  display: inline-block;
  font-weight: bold;
  border-radius: 50%;
  vertical-align: middle;
  margin-right: 0.5em;
  width: 40px;
  height: 40px;
  line-height: 40px;
  text-align: center;
}
[data-initials-ticket] {
  --initial-ticket-color: #192A53;
}
[data-initials-ticket]:before {
  /* background: #192A53; */
  background-color: var(--initial-ticket-color);
  font-size: 8px;
  color: white;
  opacity: 1;
  content: attr(data-initials-ticket);
  display: inline-block;
  font-weight: bold;
  border-radius: 50%;
  vertical-align: middle;
  margin-right: 1em;
  width: 40px;
  height: 40px;
  line-height: 40px;
  text-align: center;
}
.identicons {
  vertical-align: top;
  margin-right: 1em;
}
/*quoted message*/
.message-item .content{
  position: relative;
}
.quoted-message{
  width: auto;
  display: inline-block;
  background: #c9fcc7;
  color: rgba(24,41,83,0.7);
  padding: 8px 15px;
  border-radius: 4px;
  -moz-border-radius: 4px;
  -webkit-border-radius: 4px;
  position: relative;
  z-index: 2;
  margin-bottom: -10px;
  transform: translateY(-20px);
  -moz-transform: translateY(-20px);
  -webkit-transform: translateY(-20px);
}
.quoted-message:hover {
  color: rgba(24,41,83,0.7);
}
.quoted-reply-message{
  width: auto;
  display: inline-block;
  background: #ffffff;
  color: rgba(65, 65, 65, 0.7);
  padding: 8px 25px;
  border-radius: 4px;
  border-style: solid;
  border-color: rgba(65, 65, 65, 0.7);
  -moz-border-radius: 4px;
  -webkit-border-radius: 4px;
  position: relative;
  z-index: 2;
  margin-top: 5px;
  transform: translateY(-20px);
  -moz-transform: translateY(-20px);
  -webkit-transform: translateY(-20px);
}
.quoted-reply-message:hover {
  color: rgba(24,41,83,0.7);
}
.message-item.me{
  text-align: left;
}
.message.has-quote{
  margin-top: 16px;
}

/* reply area */
.input-group input.private,
.input-group textarea.private,
.nav-tabs .nav-link.active#private-tab{
  background: #FBFBF3;
}

.chat-footer .search-form .input-group{
  /* height: 45px !important; */
  position: relative;
}

/* textarea#chatForm,
textarea#privateForm{
  padding: 12px 20px 12px 30px;
  height: 40px;
  border-radius: 20px;
  -moz-border-radius: 20px;
  -webkit-border-radius: 20px;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
} */

textarea#chatForm{
  padding: 12px 20px 12px 30px;
  height: 40px;
  border-radius: 20px;
  -moz-border-radius: 20px;
  -webkit-border-radius: 20px;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
}
textarea#privateForm{
  padding: 12px 20px 12px 30px;
  height: 55px;
  border-radius: 20px;
  -moz-border-radius: 20px;
  -webkit-border-radius: 20px;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
}

.pr{
  position: relative;
}

.status-read{
  color: rgb(52, 183, 241);
}
.inbound-text{
  color: #000
}

/* Product */
.thumbnail-product {
  background-color: #ccd0d5;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: auto 100%;
  border-radius: 4px;
  box-sizing: border-box;
  /* width: 240px; */
}

.thumbnail-product::after {
  content: '';
  display: block;
  padding-top: calc(100% * (1 / 1.91));
}

.email-thread {
  margin-top: 10px;
  font-size: 14px;
  color: gray;
}

.email-thread summary {
  cursor: pointer;
  color: blue;
}
.toggle-thread {
  background: none;
  border: none;
  color: blue;
  font-weight: bold;
  cursor: pointer;
}

.hidden-thread {
  margin-top: 8px;
  padding-left: 10px;
  border-left: 2px solid #ccc;
  font-size: 14px;
  color: gray;
}
</style>
<style lang="scss">
.button-action-system {
  margin-right: -50px !important;
  // margin-left: -20px !important;
  text-align: right !important;
}
.messages .message-item {
  &.system {
    margin: auto;
    .content {
      order: 1;
      margin: auto !important;
      // margin-left: -20px !important;
      color: #212529;
      .bubble {
        background: #e7e7e7;
        border-radius: 5px;
        margin: auto;
        align-self: center;
        p {
          text-align: center;
        }
      }
      span {
        text-align: center;
        display: block;
      }
    }
  }
}

.messages .message-item {
  &.private_note {
    margin: auto;
    .content {
      order: 1;
      margin: auto !important;
      color: #fff;
      .bubble {
        background: #fff3d5;
        color: #000;
        border-radius: 5px;
        margin: auto;
        align-self: center;
        p {
          text-align: center;
        }
      }
      span {
        text-align: center;
        display: block;
      }
    }
  }
}
ul .message-action {
  display: flex;
  list-style: none;
  padding: 0;
}

.callout {
  padding: 10px;
  border: 1px solid #eee;
  border-left-width: 5px;
  border-radius: 5px;
  background:rgba(24,41,83,0.1);
  h4 {
    margin-top: 0;
    margin-bottom: 5px;
  }
  p:last-child {
    margin-bottom: 0;
  }
  code {
    border-radius: 3px;
  }
  & + .bs-callout {
    margin-top: -5px;
  }
}
@each $name,$color in (default,#777),(primary,#428bca),(success,#5cb85c),(danger,#d9534f),(warning,#f0ad4e),(info,#5bc0de), (bdc,#29527a) {
  .callout-#{$name} {
    border-left-color: $color;
    h4 {
      color: $color;
    }
  }
}

.bg-dark-incomingcall {
  background-color: #101623 !important;
}
.modal-content-incomingcall {
  border: 2px solid #474747;
  background-color: #101623;
  border-radius: 1.135rem;
}
.modal-header-incomingcall {
  /* border-bottom: 1px solid #474747; */
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
}
.modal-body-incomingcall {
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
  border-bottom-left-radius: 1rem;
  border-bottom-right-radius: 1rem;
}
.border-header-incomingcall {
  border-bottom: 2px solid #474747 !important;
}
</style>
